<template>
  <div id="app">
    <div
      id="not-found"
      data-ui="not-found"
      class="not-found__container"
    >
      <h1>We're sorry...</h1>
      <p>The page you're looking for is not available for one of the following reasons:</p>
      <cdr-list modifier="unordered">
        <li>The link to this page may be incorrect or out-of-date.</li>
        <li>You may have bookmarked a page that has been moved.</li>
      </cdr-list>
      <p>
        Please continue shopping from our
        <cdr-link href="/">
          homepage
        </cdr-link> or use our search feature.
        You can also
        <cdr-link href="/help?a=Contact-Us---id--aFj609qjS7SEyNng9u2D9Q">
          contact us
        </cdr-link> for help.
      </p>
    </div>
  </div>
</template>

<script>
import { CdrList, CdrLink } from '@rei/cedar';

export default {
  name: 'NotFound',
  components: {
    CdrList,
    CdrLink,
  },
  mounted() {
    if (window.metrics) {
      const siteId = 'rei';
      const templateType = 'error';
      const pageName = `${siteId}:${templateType}`;
      window.metrics.view({ pageName, templateType, siteId });
    }
  },
};
</script>

<style lang="scss">
  @import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
  .not-found__container {
    @include cdr-container;
    margin-top: $cdr-space-two-x;
  }
  .not-found__container ul {
    margin: 0 $cdr-space-three-quarter-x $cdr-space-three-quarter-x;
  }
</style>
